import { cn } from '@/lib/utils'

type BadgeVariant = 'popular' | 'premium'

interface PlanBadgeProps {
  variant: BadgeVariant
  className?: string
}

const badgeStyles: Record<BadgeVariant, string> = {
  popular: 'bg-violet-500 text-white',
  premium: 'bg-gradient-to-r from-amber-500 to-amber-400 text-black',
}

const badgeLabels: Record<BadgeVariant, string> = {
  popular: 'Most Popular',
  premium: 'Maximum Performance',
}

export function PlanBadge({ variant, className }: PlanBadgeProps) {
  return (
    <div
      className={cn(
        'px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap',
        badgeStyles[variant],
        className
      )}
    >
      {badgeLabels[variant]}
    </div>
  )
}
